/*
 * Copyright © 2017, Rezo Zero
 *
 * @file FadeTransition.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import { AbstractTransition } from 'starting-blocks'
import { TweenLite } from 'gsap'
import Dispatcher from '../utils/Dispatcher'

/**
 * Fade Transition class example. Fade Out / Fade In content.
 */
export default class FadeTransition extends AbstractTransition {
    /**
     * Entry point of the animation
     * Automatically called on init()
     */
    start () {
        // Wait new content and the end of fadeOut animation
        // this.newPageLoading is a Promise which is resolved when the new content is loaded
        Promise.all([this.newPageLoading, this.fadeOut()])
        // then fadeIn the new content
            .then(this.fadeIn.bind(this))
    }

    /**
     * Fade out the old content.
     * @returns {Promise}
     */
    fadeOut () {
        return new Promise((resolve) => {
            this.oldPage.locked = true
            this.oldPage.setLocked(true)

            TweenLite.to(this.oldPage.$cont, 0.4, {
                autoAlpha: 0,
                onComplete: resolve
            })
        })
    }

    /**
     * Fade in the new content
     */
    fadeIn () {
        // Add display: none on the old container
        this.oldPage.$cont[0].style.display = 'none'

        // Destroy smooth scroll
        Dispatcher.commit('scroll.destroy')

        // Prepare new content css properties for the fade animation
        TweenLite.set(this.newPage.$cont, {
            autoAlpha: 0
        })

        // Srolltop
        window.scrollTo(0, 0)

        // fadeIn the new content container
        TweenLite.to(this.newPage.$cont, 0.4, {
            autoAlpha: 1,
            onComplete: () => {
                this.done()
            },
            onStart: () => {
                // Init smooth scroll
                Dispatcher.commit('scroll.init')
            }
        })
    }
}



// WEBPACK FOOTER //
// ./webpack/js/transitions/FadeTransition.js